<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="addTaxPerson"
                            type="button">
                        <icon name="plus"></icon> เพิ่มเรทภาษี
                    </button>&nbsp;&nbsp;
                    &nbsp;
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">ลำดับ</th>
                        <th scope="col">เงินรายปีเริ่มต้น</th>
                        <th scope="col">ถึงเงินรายปีสิ้นสุด</th>
                        <th scope="col">ภาษีที่ต้องจ่าย</th>
                        <th scope="col">วันที่บันทึก</th>
                        <th scope="col">แก้ไข/ลบ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(data,index) in taxPersonList">
                        <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                        <td>{{data.salary_min | currency}}</td>
                        <td>
                            <template v-if="data.salary_max == 0">
                                -
                            </template>
                            <template v-else>
                                {{data.salary_max | currency}}
                            </template>
                        </td>
                        <td>
                            <template v-if="data.unit_id == 1">
                                {{data.amount | currency}} บาท
                            </template>
                            <template v-else>
                                {{data.amount}} %
                            </template>
                        </td>
                        <td>{{data.created_at | moment('DD/MM/YYYY')}}</td>
                        <td>
                            <a @click="showTaxPerson(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp;&nbsp;
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash"></icon>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- ----Modal Add Social Security---- -->
        <b-modal hide-header hide-footer ref="add_social_security">
        </b-modal>

        <!-- ----Modal delete Social Security---- -->
        <b-modal hide-header hide-footer ref="delete_tax_data">
            <delete-confirm-modal @submit="deleteTaxRate"></delete-confirm-modal>
        </b-modal>

        <div v-if="taxPersonList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getTaxPerson">
            </vue-pagination>
        </div>
        <br>
        <b-modal hide-footer hide-header ref="tax_person">
            <rate-tax-person-modal @submit="saveTaxPerson"></rate-tax-person-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
           <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import Multiselect from "vue-multiselect"
    import VuePagination from "../../../Pagination";
    import moment from "moment";
    import DatePicker from 'vue2-datepicker'
    import RateTaxPersonModal from "./Modal/RateTaxPersonModal";
    import Loading from "../../../Utility/Loading";
    import RateSocialSecurityModal from "./Modal/RateSocialSecurityModal";
    import DeleteConfirmModal from "../../../Utility/DeleteConfirmModal";

    export default {
        name: "rate-tax-person-table",
        components: {
            DeleteConfirmModal,
            RateSocialSecurityModal,
            Loading,
            RateTaxPersonModal,
            Multiselect,
            VuePagination,
            DatePicker
        },
        created(){
            this.$store.dispatch("SocialSecurity/clearFormData");
            this.getTaxPerson();
        },
        data() {
            return {
                msg : '',
                status_loading : 1,
                event_submit: false,
                delete_id : '',
                dataPaginate: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 1,
                    to: 1
                },
                taxPersonList:[],
            };
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.SocialSecurity.form_tax;
                },
            }),
        },
        methods:{
            hideTaxPersonModal(){
                this.$refs.tax_person.hide();
            },
            showTaxPersonModal() {
                this.$refs.tax_person.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideDeleteModal(id){
                this.$refs.delete_tax_data.hide();
            },
            showDeleteModal(id) {
                this.delete_id = id;
                this.$refs.delete_tax_data.show();
            },
            getTaxPerson(page){
                this.$store.dispatch("SocialSecurity/getTaxPerson",page).then(res=>{
                    this.taxPersonList = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                })
            },
            addTaxPerson(){
                this.$store.dispatch("SocialSecurity/clearFormData").then(()=>{
                    this.showTaxPersonModal();
                });
            },
            saveTaxPerson(value){
                if(value){
                    let data = {
                        id : value.id,
                        data:value,
                    }
                    this.msg = "กรุณารอสักครู่";
                    this.status_loading = 1;
                    this.showLoadingModal();
                    this.$store.dispatch("SocialSecurity/saveTaxPerson",data).then(()=>{
                        this.getTaxPerson();
                        this.hideLoadingModal();
                    }).catch(()=>{
                        this.msg = "บันทึกไม่สำเร็จ";
                        this.status_loading = 3;
                        this.showLoadingModal();
                    })
                }
                this.hideTaxPersonModal();
            },
            showTaxPerson(id){
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = "กรุณารอสักครู่";
                this.$store.dispatch("SocialSecurity/showTaxPerson",id).then(()=>{
                    this.hideLoadingModal();
                    this.showTaxPersonModal();
                })
            },
            deleteTaxRate(value){
                if(value){
                    this.showLoadingModal();
                    this.status_loading = 1;
                    this.msg = "กรุณารอสักครู่";
                    this.$store.dispatch("SocialSecurity/deleteTaxPerson",this.delete_id).then(()=>{
                        this.status_loading = 2;
                        this.msg = "ลบรายการสำเร็จ";
                    }).then(()=>{
                        this.getTaxPerson(this.dataPaginate.current_page);
                    })
                }
                this.hideDeleteModal();
            }
        }
    }
</script>

<style scoped>

</style>
